import {initializeRoutes} from "../../router";
import {deepCopy} from "../../common/base";

const state = {
  roles: [],         // 存储角色
  menus: [],         // 存储菜单权限
  menu: {},          // 当前页菜单权限
  fields: [],         // 存储字段信息
  departments: []        // 存储部门信息
};

const mutations = {
  SET_PERMISSIONS(state, permissions) {
    state.roles = permissions.roles || [];
    const menus = deepCopy(permissions.menus).filter(item => item.platformType === 1);
    recursion(menus);
    state.menus = menus;
    // 动态路由
    // initializeRoutes();
    state.fields = permissions.fields || []
    console.log(state)
  },
  CLEAR_PERMISSIONS(state) {
    state.roles = [];
    state.menus = [];
    state.fields = [];
    state.departments = []; // 清空字段
  },
  SET_MENU_PERMISSION(state, name) {
    state.menu = findMenuByPath(name, state.menus);
    // console.log("当前menu",state.menu)
  },
  SET_FIELDS(state, fields) {
    state.fields = fields; // 设置字段信息
  },
  SET_DEPARTMENTS(state, depts) {
    state.departments = depts; // 设置字段信息
  }
};

const actions = {
  setPermissions({commit}, permissions) {
    commit('SET_PERMISSIONS', permissions);
  },
  setMenu({commit}, name) {
    commit('SET_MENU_PERMISSION', name);
  },
  clearPermissions({commit}) {
    commit('CLEAR_PERMISSIONS');
  },
  setFields({commit}, fields) {
    commit('SET_FIELDS', fields); // 设置字段信息
  },
  setDepartments({commit}, depts) {
    commit('SET_DEPARTMENTS', depts);
  }
};

const getters = {
  getRoles: (state) => state.roles,
  getMenus: (state) => state.menus,
  getCurrentMenu: (state) => state.menu,
  getFields: (state) => state.fields,
  getDepartments: (state) => state.departments // 获取字段信息
};

function recursion(menus) {
  menus.forEach(menu => {
    try {
      menu.meta = JSON.parse(menu.meta);
    } catch (error) {
      console.error('Meta 字段解析失败:', error);
      menu.meta = {};
    }
    if (menu.childrenMenus && menu.childrenMenus.length > 0) {
      recursion(menu.childrenMenus);
    }
  });
}


function findMenuByPath(name, menus) {
  for (let menu of menus) {
    const nameStr = name.includes("?") ? name.split("?")[0] : name;
    if (nameStr === menu.path) {
      return menu; // 找到匹配的菜单，返回
    }

    if (menu.children) {
      const found = findMenuByPath(name, menu.children); // 递归查找
      if (found) {
        return found; // 如果在子菜单中找到，返回
      }
    }
  }
  return null; // 如果没有找到，返回 null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/mutations/permission.js